import { IPrismicImage } from '@lib/prismic/types';

export interface ICTA {
  text: string;
  url: string;
}

export interface IFeaturedItem {
  title: string;
  description: string;
  image?: IPrismicImage | null;
  cta?: ICTA;
}

export interface IShopPageData {
  title: string;
  description?: string;
  image?: string | IPrismicImage | null;
  featuredItems: IFeaturedItem[];
}

export enum ShopPageType {
  SEARCH_RESULTS,
  MERCH_GROUP,
  MERCH_GROUP_CATEGORY,
  VENDOR_GROUP
}
